import React from 'react'
import rk from './img/rk.jpg'

const Section = () => {
  return (
    <div className='section'>

        <img src={rk}/>
    </div>
  )
}

export default Section